import React from "react";
import ContentBox from "../../components/UI/ContentBox";
import Footer from "../../components/UI/Footer";
import Menu from "../../components/UI/Menu";
import {
  Container,
  Images,
  LinkDoc,
  Text,
  ViewImages,
} from "./styles";
import Banner from "../../components/UI/Banner";
import { images } from "../../constants";
import cidadeLeitora from "../../assets/docs/cidadeLeitora.pdf";

import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";

const ProjectReaderCity = () => {
  
  const openPadletCid = () => {
    window.open("https://padlet.com/cidadeleitora1/projeto-mogi-cidade-leitora-lhzi9bsbkbrhd2q0");
  };

  const imagesGalery = [
      {
        original: images.readercity1,
        thumbnail: images.readercity1,
      },
      {
        original: images.readercity2,
        thumbnail: images.readercity2,
      },
      {
        original: images.readercity3,
        thumbnail: images.readercity3,
      },
      {
        original: images.readercity4,
        thumbnail: images.readercity4,
      },
      {
        original: images.readercity5,
        thumbnail: images.readercity5,
      },
      {
        original: images.readercity6,
        thumbnail: images.readercity6,
      },
      {
        original: images.readercity7,
        thumbnail: images.readercity7,
      },    
  
    ];

  return (
  
    <Container>
      <Menu />
      <Banner icon={images.icon_cidadeleitora}>MOGI CIDADE LEITORA</Banner>
      <ContentBox>

            <ViewImages>
              <Images>
                <ImageGallery 
                items={imagesGalery} 
                showBullets={true} 
                autoPlay={true} 
                showNav={false} 
                thumbnailPosition={"right"} 
                />
              </Images>
            </ViewImages>

            <Text>
              O projeto Mogi, Cidade Leitora tem a missão de fomentar o prazer da leitura, para que ela faça parte da vida de todos,
              não só durante as aulas e nas escolas, mas como um ato constituído por diversas ações, possibilitando a vivência de um
              panorama diversificado da leitura e da literatura em nossa cidade.
            </Text>

          <LinkDoc href={cidadeLeitora} target="_blank">* Conheça o projeto (Clique aqui)</LinkDoc>
          <LinkDoc onClick={openPadletCid}>*Visite o mural virtual do projeto e conheça suas ações (Clique aqui)</LinkDoc>

          Ações realizadas pelo projeto em 2024:
          <iframe width="600" height="338" src="https://www.youtube.com/embed/9R0UKlXFcrk" title="Encerramento do Projeto Mogi, Cidade Leitora - 2024" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          
          Ações realizadas pelo projeto em 2023:          
          <iframe width="600" height="338" src="https://www.youtube.com/embed/v8emKXicbEY" title="Encerramento do Projeto Mogi, Cidade Leitora - 2023" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          
      </ContentBox>
      <Footer />
    </Container>
  );
};

export default ProjectReaderCity;